import React, { Component } from "react";
import { Form, Row, Col } from "reactstrap";
import FormComponent from "../../../../common/FormComponent";
import { withRouter } from "react-router-dom";
import {
  Validator,
  submitValidator,
  refresh,
  valid,
} from "../../../../common/Validator";
import Notifier from "../../../aside/Notifier";
import ErrorNotifier from "../../../aside/ErrorNotifier";
import axios from "axios";
import { API_CANDIDATE,RS_API } from "../../../../utils/config";
import Button from "@material-ui/core/Button";
import CountryCodeList from "./countrycodelist"
import { getProfileInfo} from "../../../../redux/action/profileInfoAction"
import { connect } from "react-redux";

/**
 * UpdateContactDetails Component for updating the contact details.
 */
class UpdateContactDetails extends Component {
  constructor(props) {
    super(props);

    console.log(this.props.data[0]);
    this.state = {
      alternativeNo: this.props.data.length
        ? this.props.data[0].alternateContactNo
        : "",
      AlternateEmailId: this.props.data.length
        ? this.props.data[0].alternateEmailId
        : "",

      currentAddress: this.props.data.length
        ? this.props.data[0].currentAddress
        : "",
      permanentAddress: this.props.data.length
        ? this.props.data[0].permanentAddress
        : "",

      id: this.props.data[0] ? this.props.data[0].id : undefined,
      message: "",
      error: "",
      dialingCode:"+91",
      getCountryCode:[]
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.getCountryData = this.getCountryData.bind(this)
  }
  // common onchange function 
  onChange(e) {
    Validator(e.target);
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
// submit function by clicking update button
  onSubmit(e) {
    e.preventDefault();
    submitValidator(e.target);
    let data = {
      canInfoId:this.props.profile.data.id,
      dialingCode:this.state.dialingCode,
      alternateContactNo: this.state.alternativeNo,
      alternateEmailId: this.state.AlternateEmailId,
      currentAddress: this.state.currentAddress,
      permanentAddress: this.state.permanentAddress,
    };
    console.log(data);
    if (valid) {
      axios
        .post(`${API_CANDIDATE}/v1/api/can-contact`, data, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "successfully created",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:"Access Denied"
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }
// update function by clicking update button
  onUpdate(e) {
    console.log(this.state.id);
    console.log(e, "updating");
    e.preventDefault();
    submitValidator(e.target);
    let data = {
      canInfoId:this.props.profile.data.id,
      dialingCode:this.state.dialingCode,
      id: this.state.id,
      alternateContactNo: this.state.alternativeNo,
      alternateEmailId: this.state.AlternateEmailId,
      currentAddress: this.state.currentAddress,
      permanentAddress: this.state.permanentAddress,
    };
    if (valid) {
      axios
        .put(`${API_CANDIDATE}/v1/api/can-contact`, data, { withCredentials: true })
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "successfully updated ",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:"Access Denied"
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }

// get country code list from RS
  getCountryData() {
    axios
      .get(`${RS_API}/v1/api/can-country`, { withCredentials: true })
      .then((res) => {
        console.log(res);
        this.setState({
          getCountryCode: res.data,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }


  componentDidMount() {
    this.getCountryData()
    this.props.getProfileInfo();
    refresh();
    this.setState({
      message: "",
      error: "",
    });
  }

  render() {
    const {
      alternativeNo,
      AlternateEmailId,
      currentAddress,
      permanentAddress,
      message,
      error,
    } = this.state;

    return (
      <>
         {/* applied ternary operator for checking whether it is update or submit form */}
        {this.props.data.length ? (
          <div style={{ paddingLeft: "60px" }}>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "24px",
                fontWeight: "bold",
                paddingTop: "0.5rem",
              }}
            >
              <span>Contact Details</span>
            </div>
            <Form onSubmit={this.onUpdate} className="p-3" noValidate>
              <Row>
                <Col md="6">
                  <span className="bold label-sm">Mobile Number</span>
                  <div style={{ display: "flex", width: "100%" }}>
                    <CountryCodeList
                      tab="1"
                      widthValue="60px"
                      getCountryCode={this.state.getCountryCode}
                      value={this.state.dialingCode}
                      // onChange={this.handleDialingCodeChange}

                      // countries={countries}
                    />
                    <div style={{width:"100%"}}>
                    <FormComponent
                      style={{
                        height: "50px",
                        width: "100%",
                        marginTop: "10px",
                      }}
                      index="2"
                      labelClass="bold label-sm"
                      // label="Alternative Contact No."
                      type="tel"
                      name="alternativeNo"
                      inputClass="form-control-sm"
                      value={alternativeNo}
                      change={this.onChange}
                      required={true}
                    />
                    </div>
                  </div>

                  <FormComponent
                    index="4"
                    style={{ height: "50px", marginTop: "10px" }}
                    labelClass="bold label-sm"
                    label="Current Address"
                    type="textarea"
                    minlength="2"
                    maxlength="75"
                    name="currentAddress"
                    inputClass="form-control-sm"
                    value={currentAddress}
                    change={this.onChange}
                    required={true}
                  />
                </Col>
                <Col md="6">
                  <FormComponent
                   index="3"
                    style={{ height: "50px",marginTop:"0.2rem" }}
                    labelClass="bold label-sm"
                    label="Alternative Email Id"
                    type="email"
                    name="AlternateEmailId"
                    inputClass="form-control-sm"
                    value={AlternateEmailId}
                    change={this.onChange}
                    required={true}
                  />

                  <FormComponent
                   index="5"
                    style={{ height: "50px",marginTop:"0.5rem" }}
                    labelClass="bold label-sm"
                    label="Permanent Address"
                    type="textarea"
                    minlength="2"
                    maxlength="75"
                    name="permanentAddress"
                    inputClass="form-control-sm"
                    value={permanentAddress}
                    change={this.onChange}
                    required={true}
                  />
                </Col>
              </Row>
              <div className="center">
                <Button
                  type="submit"
                  style={{
                    background: "#0984e3",
                    color: "white",
                    marginTop: "10px",
                  }}
                  className="btn login-button white-text"
                >
                  Update
                </Button>
              </div>
            </Form>

            {message && <Notifier message={message} />}
            {error && <ErrorNotifier message={error} />}
          </div>
        ) : (
          <div>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "24px",
                fontWeight: "bold",
                paddingTop: "0.5rem",
              }}
            >
              <span>Contact Details</span>
            </div>
            <Form onSubmit={this.onSubmit} className="p-3" noValidate>
              <Row>
                <Col md="6">
                  <span className="bold label-sm">Alternative Contact No</span>
                  <div style={{ display: "flex", width: "100%" }}>
                    <CountryCodeList
                      tab="1"
                      widthValue="60px"
                      getCountryCode={this.state.getCountryCode}
                      value={this.state.dialingCode}
                      // value={this.state.dialingCode}
                      onChange={(e) =>
                        this.setState({
                          dialingCode: e.target.value,
                        })
                      }

                      // countries={countries}
                    />
                    <div style={{width:"100%"}}>
                    <FormComponent
                     index="2"
                      style={{
                        height: "50px",
                        width: "100%",
                        marginTop: "10px",
                        flex:1
                      }}
                      labelClass="bold label-sm"
                      // label="Alternative Contact No."
                      type="tel"
                      name="alternativeNo"
                      inputClass="form-control-sm"
                      value={alternativeNo}
                      change={this.onChange}
                      required={true}
                    />
                    </div>
                  </div>

                  <FormComponent
                    index="4"
                    style={{ height: "80px", marginTop: "10px" }}
                    labelClass="bold label-sm"
                    label="Current Address"
                    type="textarea"
                    name="currentAddress"
                    minlength="2"
                    maxlength="75"
                    inputClass="form-control-sm"
                    value={currentAddress}
                    change={this.onChange}
                    required={true}
                  />
                </Col>
                <Col md="6" style={{marginTop:'9px'}}>
                  <FormComponent
                   index="3"
                    style={{ height: "50px", marginTop: "0.2rem" }}
                    labelClass="bold label-sm"
                    label="Alternative Email Id"
                    type="email"
                    name="AlternateEmailId"
                    inputClass="form-control-sm"
                    value={AlternateEmailId}
                    change={this.onChange}
                    required={true}
                  />

                  <FormComponent
                   index="5"
                    style={{ height: "80px",marginTop: "0.5rem" }}
                    labelClass="bold label-sm"
                    label="Permanent Address"
                    type="textarea"
                    minlength="2"
                    maxlength="75"
                    name="permanentAddress"
                    inputClass="form-control-sm"
                    value={permanentAddress}
                    change={this.onChange}
                    required={true}
                  />
                </Col>
              </Row>
              <div className="center">
                <Button
                  tabIndex="6"
                  type="submit"
                  style={{
                    background: "#0984e3",
                    marginTop: "30px",
                    color: "white",
                  }}
                  className="btn login-button white-text"
                >
                  Submit
                </Button>
              </div>
            </Form>

            {message && <Notifier message={message} />}
            {error && <ErrorNotifier message={error} />}
          </div>
        )}
      </>
    );
  }
}


const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps,{getProfileInfo})(
  withRouter(UpdateContactDetails)
);
